// React
import React, { useEffect, useRef } from "react";
// React
// CSS
import styles from "./SelectOptionBuilderModal.module.css";
import Spinner from "../../Spinner/Spinner";
// CSS

type SelectOptionBuilderModalProps = {
  dataForBuildOptions: {
    title: string;
    id: number | string;
  }[];
  onClick: (data: string) => void;
  setSelectedItem: React.Dispatch<React.SetStateAction<string>>;
  setIsModalInView: React.Dispatch<React.SetStateAction<boolean>>;
  style?: React.CSSProperties;
};

const SelectOptionBuilderModal: React.FunctionComponent<
  SelectOptionBuilderModalProps
> = ({
  dataForBuildOptions,
  onClick,
  setSelectedItem,
  setIsModalInView,
  style,
}) => {
  //
  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);
  //

  useEffect(() => {
    setTimeout(() => {
      if (!outerRef.current) return;
      if (!innerRef.current) return;

      outerRef.current.style.opacity = "80%";
      innerRef.current.style.top = "-5vh";
    }, 50);
  }, []);

  const closeModal = () => {
    if (!outerRef.current) return;
    if (!innerRef.current) return;

    outerRef.current.style.opacity = "0%";
    innerRef.current.style.top = "80vh";

    setTimeout(() => {
      setIsModalInView(false);
    }, 500);
  };

  return (
    <div
      className={`${
        styles.selectOptionModalContainer
      } fixed w-screen h-screen top-0 ${
        window.innerWidth > 600 ? "left-auto" : "left-0"
      } flex items-center justify-center z-30 dark:!text-black`}
      style={{
        marginLeft: window.innerWidth > 600 ? "-54px" : "",
        ...style,
      }}
    >
      <div
        className={`${styles.outer} absolute w-screen h-screen z-40 top-0 left-0 dark:!text-black`}
        ref={outerRef}
        onClick={closeModal}
      ></div>
      <div
        className={`${
          styles.inner
        }  flex flex-col items-center z-50 relative w-full mx-8 rounded-2xl p-4 bg-white overflow-y-scroll dark:!text-black ${
          dataForBuildOptions.length === 0 ? "bg-purple-400" : ""
        }`}
        ref={innerRef}
      >
        {dataForBuildOptions.length !== 0 ? (
          dataForBuildOptions.map((item) => (
            <p
              key={item.id}
              onClick={() => {
                onClick(String(item.id));
                setSelectedItem(item.title);
                closeModal();
              }}
              className="py-4 w-full text-right"
            >
              {item.title}
            </p>
          ))
        ) : (
          <div className="bg-purple-500 flex justify-center items-center rounded-full p-4 ">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectOptionBuilderModal;
